import { render, staticRenderFns } from "./slaccountbank-add-or-update.vue?vue&type=template&id=0a4bd870&"
import script from "./slaccountbank-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slaccountbank-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports